import React, { useState } from "react";
import Button from "../../components/Button";
import "react-datepicker/dist/react-datepicker.css";
import { NavLink } from "react-router-dom";
import { Klass } from "../../types";
import useClasses from "../../hooks/useClasses";
import useTeachers from "../../hooks/useTeachers";
import useStudents from "../../hooks/useStudents";
import Wrapper from "../../components/Layout/Wrapper";
import { Input } from "antd";
import { nanoid } from "nanoid";
import useAuth from "../../hooks/useAuth";

const DEFAULT_CLASS: Partial<Klass> = {
  teachers: [],
  students: [],
  activities: [],
  sessions: [],
};

const Classes = () => {
  const { accountDetails, isSuperUser } = useAuth();
  const [search, setSearch] = useState("");
  const [newClass, setNewClass] = useState({ name: "" });
  const {
    isLoading,
    error,
    data,
    addClassToFirebase,
    removeClass,
  } = useClasses();
  const { data: teacherData } = useTeachers();
  const { data: studentData } = useStudents();

  const onAddClass = () => {
    if (newClass.name) {
      addClassToFirebase({
        ...DEFAULT_CLASS,
        id: nanoid(),
        name: newClass?.name || "New class",
      });
    }
  };

  if (isLoading) {
    return <div>Loading</div>;
  }

  if (error) {
    return <div>ERROR: {JSON.stringify(error)}</div>;
  }

  if (!data) {
    return <div>No data</div>;
  }

  return (
    <div>
      <Wrapper style={{ flexDirection: "column", marginTop: 32 }}>
        <h1>Classes</h1>
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search"
        />
        <table className="yc-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Teachers</th>
              <th>Students</th>
              <th>Assigned Activities</th>
              <th>Sessions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data
              .filter((x) =>
                search
                  ? x.name.toLowerCase().includes(search.toLowerCase())
                  : true
              )
              .filter((x) => {
                if (accountDetails?.isSuperuser) {
                  return true;
                }
                return (x.teachers || []).some(
                  (t) => t.teacherId === accountDetails?.id
                );
              })
              .map((klass) => (
                <tr key={klass.id}>
                  <td>
                    <NavLink to={`/class/${klass.id}`}>{klass.name}</NavLink>
                  </td>
                  <td>
                    {(klass.teachers || []).map((teacher) => (
                      <div>
                        {
                          teacherData?.find(
                            (x) => x.teacherId === teacher.teacherId
                          )?.name
                        }{" "}
                        {teacher.role}
                      </div>
                    ))}
                  </td>
                  <td>
                    {(klass.students || []).map((student) => (
                      <div>
                        {studentData?.find((x) => x.id === student.id)?.name}
                      </div>
                    ))}
                  </td>
                  <td>
                    {(klass.activities || []).map((activity) => (
                      <div>{activity.name}</div>
                    ))}
                  </td>
                  <td>
                    {(klass.sessions || []).map((session) => (
                      <div>{session.name}</div>
                    ))}
                  </td>
                  <td>
                    {isSuperUser && (
                      <Button
                        small
                        variant="secondary"
                        onClick={() => removeClass(klass.id)}
                      >
                        Remove
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            {accountDetails?.isSuperuser && (
              <tr>
                <td>
                  <Input
                    placeholder="Class Name"
                    value={newClass.name}
                    autoFocus
                    onKeyDown={(e) => {
                      if (e.key === "Enter") onAddClass();
                    }}
                    onChange={(e) =>
                      setNewClass({ ...newClass, name: e.target.value })
                    }
                  />
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <Button small variant="secondary" onClick={onAddClass}>
                    Add
                  </Button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Wrapper>
    </div>
  );
};

export default Classes;
